import { ConfigurationService } from './configuration.service';
import { RoleInterface } from '../interfaces/role-interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnyValue } from '@shared/types/any-value.type';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  ROLES_ROUTE_API = 'api/v1.0/role';
  ROLES_STORAGE_KEY = 'roles';

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly configService: ConfigurationService,
  ) {}

  public getRoles(): Observable<AnyValue> {
    return this.httpClient.get<AnyValue>(`${this.configService.urlApiSiVision}/${this.ROLES_ROUTE_API}`).pipe(
      map((data) => {
        return this.apiRoleToAppRole(data);
      }),
      tap((roles) => {
        this.setRolesSessionStorage(roles);
      }),
    );
  }

  public setRolesSessionStorage(role: ReadonlyArray<RoleInterface>) {
    sessionStorage.setItem(this.ROLES_STORAGE_KEY, JSON.stringify(role));
  }

  public get roles(): ReadonlyArray<RoleInterface> | null {
    const roles: string | null = sessionStorage.getItem(this.ROLES_STORAGE_KEY);
    if (!roles) return null;
    return JSON.parse(roles);
  }

  public get roles$(): Observable<ReadonlyArray<RoleInterface> | null> {
    return of(this.roles);
  }

  public apiRoleToAppRole(data: RoleInterface): ReadonlyArray<RoleInterface> {
    const appRoles: Array<RoleInterface> = [];
    if (data) {
      for (const [key, value] of Object.entries(data)) {
        appRoles.push({
          id: key,
          name: value,
        });
      }
    }
    return appRoles;
  }
}
